import { apiClient } from './axios';

export type InvoiceStatus = 'draft' | 'sent' | 'paid' | 'overdue' | 'void';

export interface InvoiceLineItem {
  description: string;
  quantity: number;
  unitPrice: number;
  amount: number;
}

export interface BusinessAddressSnapshot {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
}

export interface Invoice {
  id: string;
  businessId: string;
  bookingId: string | null;
  invoiceNumber: string;
  customerName: string;
  customerEmail: string | null;
  customerPhone: string | null;
  customerClerkId: string | null;
  lineItems: InvoiceLineItem[];
  subtotal: number;
  taxRate: number;
  taxAmount: number;
  discountAmount: number;
  total: number;
  currency: string;
  status: InvoiceStatus;
  paymentMethod: string | null;
  paymentReference: string | null;
  paidAt: string | null;
  dueDate: string | null;
  notes: string | null;
  businessName: string | null;
  businessLogoUrl: string | null;
  businessAddress: BusinessAddressSnapshot | null;
  createdAt: string;
  updatedAt: string;
}

// Get invoices billed to the authenticated pet owner
export async function listMyInvoices(): Promise<Invoice[]> {
  const res = await apiClient.get<{ invoices: Invoice[] }>('/invoices');
  return res.data.invoices ?? [];
}

export async function getInvoice(id: string): Promise<Invoice> {
  const res = await apiClient.get<{ invoice: Invoice }>(`/invoices/${id}`);
  return res.data.invoice;
}
